import Vue from 'vue'
import Vuex from 'vuex'
import WebsiteState from './website/website-state'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    WebsiteState

  }
})
